module.exports = __webpack_public_path__ + "static/img/jchb1-12.71d437d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-12.png
// module id = 774
// module chunks = 0